/* eslint-disable no-template-curly-in-string */
import 'twin.macro'
import { useLocation } from '@reach/router'
import { useState } from 'react'
import { useTranslation } from '@/utils/useTranslation'
import { getLocale } from '@plugins/bw-i18next/utils'
import { Script } from 'gatsby'
import Spinner from '@/icons/bwi/spinner.svg'

function HundioWidget() {
  const [isLoading, setIsLoading] = useState(true)
  const { pathname } = useLocation()
  const { t } = useTranslation()

  return (
    <>
      <Script
        src="https://libraries.hund.io/status-js/status-3.9.0.js"
        onLoad={() => {
          if (window?.Status?.Widget)
            new window.Status.Widget({
              hostname: `https://status.bitwarden.com`,
              selector: '#hundStatus',
              i18n: {
                heading: t('Issues'),
                toggle: '${state}', // Other variables: percentUptime and incidentFreeStreak
                loading: t('Loading status...'),
                error: t('Connection error'),
                statistic: {
                  streak: t('No events for ${duration}!'),
                  uptime: t('${percent}% Uptime'),
                },
                issue: {
                  scheduled: t('Scheduled'),
                  empty: {
                    operational: t('There are currently no reported issues.'),
                    degraded: t(
                      'There are currently no reported issues, but we have detected that at least one component is degraded.'
                    ),
                    outage: t(
                      'There are currently no reported issues, but we have detected outages on at least one component.'
                    ),
                  },
                },
                state: {
                  operational: t('Operational'),
                  degraded: t('Degraded'),
                  outage: t('Outage'),
                  pending: t('Pending'),
                  outOfOffice: t('Out of Office'),
                },
                linkBack: t('View Status Page'),
                dates: {
                  locale: getLocale(pathname),
                  options: {},
                },
                time: {
                  distanceInWords: {
                    halfAMinute: t('half a minute'),
                    lessThanXSeconds: {
                      one: t('less than 1 second'),
                      other: t('less than ${count} seconds'),
                    },
                    xSeconds: {
                      one: t('1 second'),
                      other: t('${count} seconds'),
                    },
                    lessThanXMinutes: {
                      one: t('less than a minute'),
                      other: t('less than ${count} minutes'),
                    },
                    xMinutes: {
                      one: t('1 minute'),
                      other: t('${count} minutes'),
                    },
                    aboutXHours: {
                      one: t('about 1 hour'),
                      other: t('about ${count} hours'),
                    },
                    xDays: {
                      one: t('1 day'),
                      other: t('${count} days'),
                    },
                    aboutXMonths: {
                      one: t('about 1 month'),
                      other: t('about ${count} months'),
                    },
                    xMonths: {
                      one: t('1 month'),
                      other: t('${count} months'),
                    },
                    aboutXYears: {
                      one: t('about 1 year'),
                      other: t('about ${count} years'),
                    },
                    overXYears: {
                      one: t('over 1 year'),
                      other: t('over ${count} years'),
                    },
                    almostXYears: {
                      one: t('almost 1 year'),
                      other: t('almost ${count} years'),
                    },
                  },
                },
              },
            })
          setIsLoading(false)
        }}
      />
      {isLoading && <Spinner tw="mt-5 animate-spin h-8 w-8" />}
      <div id="hundStatus" />
    </>
  )
}

export default HundioWidget
